import keyWrapper from '@bufferapp/keywrapper';
import callRpc from '~/utils/call-rpc';
import { actionTypes as orgActionTypes } from '~/organizations';

export const actionTypes = keyWrapper('COMPOSER_POPOVER', {
  OPEN_COMPOSER: 0,
  HIDE_COMPOSER: 0,
  USE_SLATE_EDITOR: 0,
});

export const initialState = {
  showComposer: false,
  environment: 'production',
  editMode: false,
  emptySlotData: undefined,
  emptySlotMode: false,
  hasDefaultTime: false,
  editingPostId: '',
  shouldResetComposerData: false,
  selectedProfileId: undefined, // Provided when in the context of a single profile (e.g. queue)
  selectedProfileIds: [], // Provided when in the context of multiple profiles (e.g. calendar)
  post: undefined,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case orgActionTypes.ORGANIZATION_SELECTED:
      return {
        ...state,
        shouldResetComposerData: true,
      };

    case actionTypes.OPEN_COMPOSER:
      return {
        ...state,
        showComposer: true,
        post: action.post,
        editMode: action.editMode,
        editingPostId: action.updateId,
        emptySlotMode: action.emptySlotMode,
        hasDefaultTime: action.hasDefaultTime,
        emptySlotData: action.emptySlotData,
        selectedProfileId: action.selectedProfileId,
        selectedProfileIds: action.selectedProfileIds,
        shouldResetComposerData: action.shouldResetComposerData,
      };
    case actionTypes.HIDE_COMPOSER:
      return {
        ...state,
        shouldResetComposerData: false,
        showComposer: false,
        editMode: false,
        emptySlotMode: false,
        hasDefaultTime: false,
        emptySlotData: undefined,
        selectedProfileId: undefined,
        selectedProfileIds: [],
        post: undefined,
      };
    case actionTypes.USE_SLATE_EDITOR:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export const actions = {
  openComposer: ({
    cta,
    post,
    editMode = false,
    editingPostId,
    emptySlotMode = false,
    hasDefaultTime = false,
    emptySlotData,
    selectedProfileId,
    selectedProfileIds = [],
    shouldResetComposerData = false,
  } = {}) => ({
    type: actionTypes.OPEN_COMPOSER,
    cta,
    post,
    editMode,
    editingPostId,
    emptySlotMode,
    hasDefaultTime,
    emptySlotData,
    selectedProfileId,
    selectedProfileIds,
    shouldResetComposerData,
  }),
  handleCreatePostClick: ({
    selectedProfileId,
    selectedProfileIds,
    cta,
    post,
    shouldResetComposerData,
    hasDefaultTime = false,
  }) =>
    actions.openComposer({
      selectedProfileId,
      selectedProfileIds,
      cta,
      post,
      shouldResetComposerData,
      hasDefaultTime,
    }),

  handleEmptySlotClick: ({ profileId, emptySlotData, cta }) => ({
    type: actionTypes.OPEN_COMPOSER,
    emptySlotMode: true,
    emptySlotData,
    selectedProfileId: profileId,
    profileId,
    cta,
  }),

  hideComposer: () => ({
    type: actionTypes.HIDE_COMPOSER,
  }),

  handleEditClick: (postId) => async (dispatch) => {
    const post = await callRpc('getPost', { updateId: postId });

    dispatch({
      type: actionTypes.OPEN_COMPOSER,
      selectedProfileId: post.profileId,
      post,
      updateId: post.id,
      editMode: true,
    });
  },

  handleShareAgainClick: (postId) => async (dispatch) => {
    const post = await callRpc('getPost', { updateId: postId });

    dispatch({
      type: actionTypes.OPEN_COMPOSER,
      selectedProfileId: post.profileId,
      shouldResetComposerData: true,
      post: {
        ...post,
        // override some properties
        id: undefined,
        scheduled_at: undefined,
        scheduledAt: undefined,
        due_at: undefined,
      },
    });
  },

  handleShareLinkClick: (post, selectedProfileIds) => async (dispatch) => {
    dispatch({
      type: actionTypes.OPEN_COMPOSER,
      selectedProfileIds,
      post: {
        text: `${post.serviceLink}`,
      },
    });
  },

  handleOpenComposerFromQueryParams: ({
    selectedProfileIds,
    cta,
    post,
    shouldResetComposerData,
    hasDefaultTime = false,
  }) => {
    return actions.openComposer({
      selectedProfileIds,
      cta,
      post,
      shouldResetComposerData,
      hasDefaultTime,
    });
  },
};

export default reducer;
